export const LOAD_BULK_FILES = 'app/BulkListContainer/LOAD_BULK_FILES';
export const LOAD_BULK_FILES_SUCCESS =
  'app/BulkListContainer/LOAD_BULK_FILES_SUCCESS';
export const LOAD_BULK_FILES_ERROR =
  'app/BulkListContainer/LOAD_BULK_FILES_ERROR';
